export const MODULE = "new/payment-status";

export const STATUS_VARIANT_MAP = {
  Paid: "success",
  "Partially Paid": "warning",
  Unpaid: "danger",
  "Not Synced": "neutral",
  Refunded: "information",
};

export const EDITING_LOCKED_PAYMENT_STATUSES = ["Paid", "Partially Paid"];

export const MAX_ACTIVE_PAYMENTS_PER_ORDER = 50;
